import * as React from "react";
import Assets from "src/presentation/assets/img/assets";
import MessageRoomProjectInfo from "../../../../common/organism/message_room/message_room_project_info";
import {CustomerMessageRoomState} from "../../../../store/customer_message_room_state";

interface IProps {
    messageRoomState: CustomerMessageRoomState;
}

const CustomerMessageRoomsRight: React.FC<IProps> = (props) => {
    const {messageRoomState} = props;
    const {opponentSignature, project} = messageRoomState;

    if (!opponentSignature || !project) {
        return null;
    }

    return (
        <React.Fragment>
            <MessageRoomProjectInfo
                project={project}
                companyIcon={opponentSignature.iconURL}
                companyName={opponentSignature.name}
                projectURL={`/customer/project/${project.id}?from_message_rooms=1`}
                contractURL={`/customer/contract/registration/${project.companyID}/${
                    project.id
                }/${messageRoomState.messageRoom!.customerID}`}
                customerId={messageRoomState.messageRoom!.customerID}
                messageRoom={messageRoomState.messageRoom!}
            />

            <div>
                <a
                    href="https://www.bengo4.com/ls/vlrxfv7m/"
                    target="_blank"
                    style={{display: "block", width: 250, marginBottom: 20}}
                >
                    <img src={Assets.bengoshi} style={{width: 250}}/>
                </a>
                <a
                    href="https://www.zeiri4.com/shoukai/promotion/external-cooperation/800/?utm_source=libera&utm_medium=gaiburenkei&utm_campaign=expert_mypage"
                    target="_blank"
                    style={{display: "block", width: 250}}
                >
                    <img src={Assets.zeirishi} style={{width: 250}}/>
                </a>
            </div>
        </React.Fragment>
    );
};

export default CustomerMessageRoomsRight;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/message_rooms/right/customer_message_rooms_right.tsx